import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_NOTE_TEMPLATES } from 'src/graphql/noteTemplates.graphql'
import { NOTE_TEMPLATE_PAGE_LIMIT } from 'src/lib/notes'

import { inlineSelectProps } from './inlineSelectStyles'

const NoteTemplateOptions = ({
  selectedNoteTemplate,
  setSelectedNoteTemplate,
}) => {
  const { data: noteTemplatesList } = useQuery(GET_NOTE_TEMPLATES, {
    variables: {
      pageInfo: {
        limit: NOTE_TEMPLATE_PAGE_LIMIT,
        offset: 0,
      },
      orderBy: {
        field: 'title',
        direction: 'asc',
      },
    },
  })

  const noteTemplates = noteTemplatesList?.noteTemplates?.items ?? []

  return (
    <div className="flex flex-col gap-3 text-xs">
      {noteTemplates.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No note templates found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedNoteTemplate?.noteTemplateId}
          onChange={(value) =>
            setSelectedNoteTemplate({ noteTemplateId: value })
          }
          data={noteTemplates.map((t) => ({
            value: t.noteTemplateId,
            label: t.title,
          }))}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default NoteTemplateOptions
